module.exports = __webpack_public_path__ + "static/media/GRAVEL.22a6829b.jpg";